import React, { Component } from 'react';
import { inject, observer } from 'mobx-react';
import PropTypes from 'prop-types';
import { FormattedMessage, injectIntl, intlShape } from 'react-intl';
import { withRouter } from 'react-router';
import RouterPropTypes from 'react-router-prop-types';

import { parse } from '../../../../util/queryString';
import { modelOf } from '../../../../prop-types';
import HelperNavigation from '../../../common/HelperNavigation';
import SEOTitle from '../../../head/SEOTitle';
import PageTitle from '../../../common/PageTitle';
import RouteService from '../../../../services/RouteService';
import globalTranslations from '../../../../i18n/globalTranslations';
import Paths from '../../../../types/Paths';
import CustomerUserStore from '../../../../store/CustomerUserStore';
import BalanceUserPaymentHistory from '../BalanceUserPaymentHistory';
import ContentForState from '../../../loader/ContentForState';
import RequestState from '../../../../types/RequestState';

@observer
export class BalanceUserBalanceAccount extends Component {
  state = {
    listState: RequestState.NONE
  };

  getBreadcrumbsPath = () => {
    const { intl, routeService } = this.props;
    return routeService.transformBreadCrumbs([
      {
        text: intl.formatMessage(globalTranslations.myAccount),
        url: Paths.MyAccountBalanceUser
      },
      {
        text: intl.formatMessage(
          globalTranslations.balanceUserAccountBalanceInfo
        ),
        url: Paths.MyAccountBalanceUserPaymentHistory
      }
    ]);
  };

  componentDidMount() {
    const {
      location: { search }
    } = this.props;
    const ifValidSearch = this.getQueryPage(search);
    const page = this.getValidPage(ifValidSearch, search);
    this.maybeLoadBalancePaymentHistory(page);
  }

  componentDidUpdate(prevProps) {
    const {
      match,
      location,
      location: { search }
    } = this.props;

    if (
      prevProps.match.params.id !== match.params.id ||
      prevProps.location.search !== location.search
    ) {
      const ifValidSearch = this.getQueryPage(search);
      const page = this.getValidPage(ifValidSearch, search);
      this.maybeLoadBalancePaymentHistory(page);
    }
  }

  getQueryPage = (search) => {
    const queryParams = parse(search);
    return Number(queryParams.page);
  };

  getValidPage = (ifValidSearch, search) => {
    if (ifValidSearch) {
      return search;
    }
    return '';
  };

  maybeLoadBalancePaymentHistory = (page) => {
    const { customerUserStore } = this.props;
    customerUserStore
      .loadBalancePaymentHistory(page)
      .then(() => {
        this.setState({
          listState: RequestState.LOADED
        });
      })
      .catch((e) => {
        console.error(e);
        this.setState({
          listState: RequestState.ERROR
        });
      });
  };

  renderBalanceUserPaymentHistory = () => {
    const { customerUserStore } = this.props;

    return (
      <BalanceUserPaymentHistory
        balancePaymentHistory={customerUserStore.balancePaymentHistory}
      />
    );
  };

  render() {
    const { customerUserStore } = this.props;

    return (
      <div className="BalanceUserBalanceAccount">
        <HelperNavigation breadcrumbsPath={this.getBreadcrumbsPath()} />
        <SEOTitle title={globalTranslations.balanceUserAccountBalanceInfo} />
        <PageTitle>
          <FormattedMessage
            {...globalTranslations.balanceUserAccountBalanceInfo}
          />
        </PageTitle>
        <ContentForState
          state={customerUserStore.balancePaymentHistoryState}
          error={customerUserStore.lastError}
          forLoaded={() => this.renderBalanceUserPaymentHistory()}
        />
      </div>
    );
  }
}

BalanceUserBalanceAccount.propTypes = {
  customerUserStore: modelOf(CustomerUserStore).isRequired,
  intl: intlShape.isRequired,
  routeService: PropTypes.instanceOf(RouteService).isRequired,
  location: RouterPropTypes.location.isRequired,
  match: RouterPropTypes.match.isRequired,
};

export default injectIntl(withRouter(
  inject('routeService', 'customerUserStore')(BalanceUserBalanceAccount)
));
